import CustomModal from "../../../../../../components/ui/CustomModal";
import Loader from "../../../../../../components/ui/Loader";
import { useGetNotificationTemplatesDetailsQuery } from "../../../../../../features/notification/notificationApi";
import useError from "../../../../../../hooks/useError";
import { ModalComponentProps } from "../../../../../../types";

export default function ViewMailTemplate({
  handleClose,
  data,
  ...rest
}: ModalComponentProps<number>) {
  const {
    isLoading,
    isError,
    error,
    data: detailsData,
  } = useGetNotificationTemplatesDetailsQuery(Number(data), {
    skip: !data,
  });

  useError(isError, error, "Template details get fail");

  const details = detailsData?.data?.template;

  return (
    <CustomModal
      title="Template Preview"
      {...rest}
      handleClose={handleClose}
      width={660}
      footer={null}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="flex items-center gap-1.5 mb-5">
            <h6 className="text-header text-lg font-medium">Subject:</h6>
            <p className="text-display-body relative top-[1px]">
              {details?.mail_subject}
            </p>
          </div>

          <pre
            className="text-display-body"
            style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}
          >
            {details?.body}
          </pre>
        </>
      )}
    </CustomModal>
  );
}
